"use client";

import React from "react";
import DOMPurify from "dompurify";
import Image from "next/image";
import { getImageURL } from "@/helpers/imageURLHelper";

const ModalGalleryItem = ({
  image,
  index,
  display,
  handleImageChange,
  onClose,
  popupImageSize,
}) => {
  const sanitizedCaptionHtml = DOMPurify.sanitize(image?.caption);
  return (
    <div
      className="reveal-overlay tps-gallery-modal-overlay"
      style={{ display: display ? "flex" : "none" }}
      onClick={onClose}
    >
      <div
        id={`gallery-modal-${index}`}
        className={`gallery-modal grid-item-modal reveal ${
          popupImageSize === "large" ? popupImageSize : ""
        }`}
        role="dialog"
        aria-hidden="false"
        data-yeti-box={`gallery-modal-${index}`}
        data-resize={`gallery-modal-${index}`}
        data-i="51tqac-i"
        tabIndex="-1"
        style={{
          display: display ? "block" : "none",
          alignContent: "center",
          top: "-100px",
        }}
      >
        <button
          className="close-button"
          data-close=""
          type="button"
          onClick={onClose}
          style={{
            display: "block",
            position: "relative",
            margin: "0 0 0 auto",
            padding: "20px 0",
          }}
        >
          <span className="sr-only">Close window</span>×
        </button>
        <div
          className="tps-gallery-modal-item-wrapper"
          onClick={(e) => e.stopPropagation()}
        >
          <a
            href="#"
            className="tps-gallery-modal-control"
            data-gallery-dir="prev"
            data-gallery-array-id={`galleryItems_${index}`}
            data-target-item-id={`gallery_item_id_${index}`}
            data-target-item-index={`${index}`}
            onClick={(e) => handleImageChange(e, "previous")}
          >
            <span className="sr-only">
              previous image
              <span />
            </span>
          </a>
          <Image
            className="tps-gallery-modal-item-image"
            src={getImageURL(image?.formats?.large?.url || image?.url)}
            alt={image?.alternativeText ? image?.alternativeText : ""}
            width={image?.formats?.large?.width || image?.width}
            height={image?.formats?.large?.height || image?.height}
          />
          <a
            href="#"
            className="tps-gallery-modal-control"
            data-gallery-dir="next"
            data-gallery-array-id={`galleryItems_${index}`}
            data-target-item-id={`gallery_item_id_${index}`}
            data-target-item-index={`${index}`}
            onClick={(e) => handleImageChange(e, "next")}
          >
            <span className="sr-only">
              next image
              <span />
            </span>
          </a>
          {!!image?.caption && (
            <div
              className="tps-gallery-modal-item-text"
              dangerouslySetInnerHTML={{ __html: sanitizedCaptionHtml }}
            ></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalGalleryItem;
